import React from "react";
import styled from "styled-components";
import Fade from "react-reveal";

// images
import instagram from "../assets/images/contact/instagram.png";
import twitter from "../assets/images/contact/twitter.png";
import behance from "../assets/images/contact/behance.png";
import vimeo from "../assets/images/contact/vimeo.png";

// style
const StyledContactScreen = styled.main`
  min-height: 88vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .social-media {
    a {
      :hover {
        /* opacity: 0.5; */
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px,
          rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
          rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
      }
    }
    img {
      height: 2rem;
      margin: 0 0.4rem;
    }
  }
  .contact-details {
    a {
      :hover {
        opacity: 0.5;
      }
    }
    h4 {
      letter-spacing: 0.1rem;
      font-size: 1.3rem;
      height: 2.1rem;
      font-weight: 400;
      color: gray;
    }
    h5 {
      font-size: 1.2rem;
      font-weight: 400;
    }
  }
`;

const ContactScreen = () => {
  return (
    <StyledContactScreen>
      <div className="social-media">
        <a
          href="https://www.instagram.com/somethingforwindy"
          target="_blank"
          rel="noreferrer"
          alt="instagram"
        >
          <Fade top>
            <img src={instagram} alt="instagram" />
          </Fade>
        </a>

        <a
          href="https://twitter.com/somethingwindy"
          target="_blank"
          rel="noreferrer"
          alt="twitter"
        >
          <Fade top>
            <img src={twitter} alt="twitter" />
          </Fade>
        </a>

        <a
          href="https://www.behance.net/somethingforwindy"
          target="_blank"
          rel="noreferrer"
          alt="behance"
        >
          <Fade top>
            <img src={behance} alt="behance" />
          </Fade>
        </a>

        <a
          href="https://vimeo.com/user14858589"
          target="_blank"
          rel="noreferrer"
          alt="vimeo"
        >
          <Fade top>
            <img src={vimeo} alt="vimeo" />
          </Fade>
        </a>
      </div>
      <div className="contact-details">
        <h4>+370 672 08515</h4>

        <a href="mailto:somethingforwindy@aol.com?subject=hello&body=Hello Windy, I love your creations">
          <Fade bottom>
            <h5>somethingforwindy@aol.com</h5>
          </Fade>
        </a>
      </div>
    </StyledContactScreen>
  );
};

export default ContactScreen;
